var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: { hero: true, mobile: _vm.isMobile(_vm.$mq) } }, [
    _c("div", { staticClass: "container" }, [
      _c("header", [
        _c("h1", [_vm._v("Brilliant for Educators")]),
        _vm._v(" "),
        _c("h2", [
          _vm._v(
            "\n        Bring Brilliant into your in-person or remote classroom with our free Education plan.\n        Access interactive lessons, problem solving, classroom tools, and more!\n      "
          )
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            directives: [
              {
                name: "track",
                rawName: "v-track:click",
                value: {
                  axId: "clicked_schools_apply",
                  axType: "button"
                },
                expression:
                  "{\n          axId: 'clicked_schools_apply',\n          axType: 'button',\n        }",
                arg: "click"
              }
            ],
            staticClass: "btn blue",
            attrs: {
              href: _vm.$router.resolve({ name: "teacher_application" }).href
            }
          },
          [_vm._v("\n        Apply for access\n      ")]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "video" }, [
        _c(
          "video",
          {
            attrs: {
              preload: "auto",
              autoplay: "",
              muted: "",
              playsinline: "",
              loop: ""
            },
            domProps: { muted: true }
          },
          [
            _c("source", {
              attrs: {
                src:
                  "/site_media/version-V87e099514e4/images/homepage/hero-video.mp4",
                type: "video/mp4"
              }
            })
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }